import { prettyValue } from "../../js/utils/formatters";

function reminderLine(reminders) {
  if (!Array.isArray(reminders) || !reminders.length) return "None";
  return reminders
    .map((item) => `${item.amount || 1} ${item.unit || "hour"}`)
    .join(", ");
}

function Row({ label, value }) {
  if (!value) return null;
  return (
    <div className="appt-summary__row">
      <span className="appt-summary__label">{label}</span>
      <span>{value}</span>
    </div>
  );
}

export default function AppointmentSummary({ draft, events = [] }) {
  const hasDraft = Boolean(draft && (draft.title || draft.location || draft.contactName || draft.notes));
  const upcoming = events
    .filter((item) => item.status !== "cancelled")
    .slice(-3)
    .reverse();

  return (
    <article className="card appt-summary">
      <h2>Appointment Summary</h2>
      {hasDraft ? (
        <div className="appt-summary__block">
          <p className="appt-summary__kicker">Current details</p>
          <Row label="Title" value={draft.title || "Untitled"} />
          <Row label="When" value={[draft.date, draft.time].filter(Boolean).join(" · ")} />
          <Row label="Type" value={prettyValue(draft.type)} />
          <Row label="Repeat" value={draft.repeat && draft.repeat !== "none" ? prettyValue(draft.repeat) : ""} />
          <Row label="Location" value={draft.location} />
          <Row label="Contact" value={draft.contactName} />
          <Row label="Reminders" value={reminderLine(draft.reminders)} />
          <Row
            label="Notify"
            value={[
              draft.sendEmail ? "Email" : "",
              draft.sendPhoneCalendar ? "Phone calendar" : "",
              draft.sendDashboardAlert ? "Dashboard" : "",
            ]
              .filter(Boolean)
              .join(" · ")}
          />
          <Row label="Notes" value={draft.notes || draft.description} />
        </div>
      ) : (
        <p className="muted">Selections from Event Details appear here as you build an appointment.</p>
      )}
      {upcoming.length ? (
        <div className="appt-summary__block">
          <p className="appt-summary__kicker">On the calendar</p>
          {upcoming.map((item) => (
            <div key={item.id} className="appt-summary__event">
              <strong>{item.title || "Untitled"}</strong>
              {item.source === "hub" ? <span className="muted"> · Journey hub</span> : null}
              <Row label="When" value={[item.date, item.time].filter(Boolean).join(" · ")} />
              <Row label="Type" value={prettyValue(item.type)} />
              <Row label="Location" value={item.location} />
              <Row label="Contact" value={item.contactName} />
              <Row label="Reminders" value={reminderLine(item.reminders)} />
            </div>
          ))}
        </div>
      ) : null}
    </article>
  );
}
